// LandingPage.js
import React from 'react';
import HeroSection from '../../components/Home/HeroSection';
import FeaturesSection from '../../components/Home/FeaturesSection';
import Footer from '../../components/Home/Footer';
import Navbar from '../../components/Home/Navbar';
import CTASection from '../../components/Home/CTASection';
import HowItWorksSection from '../../components/Home/HowItWorksSection';
import MatchingSection from '../../components/Home/MatchingSection';
import HappyCustomersSection from '../../components/Home/HappyCustomersSection';
import OurAchievementSection from '../../components/Home/OurAchievementSection';
import PricingSection from '../../components/Home/PricingSection';
import CallToActionFooter from '../../components/Home/CallToActionFooter';


const LandingPage = () => (
  <>
    <Navbar />
      <HeroSection />
      <FeaturesSection />
      <CTASection />
      <HowItWorksSection />
      <MatchingSection />
      <HappyCustomersSection />
      <OurAchievementSection />
      <PricingSection />
      <CallToActionFooter />
      <Footer />
  </>
);

export default LandingPage;